import cx from 'classnames';
import { BodyCell } from '../../Cells';

export const DesktopTableContent = ({ rows, hasStickyHeader = false }) => {
  const handleClick = (e, cb) => {
    if (cb) {
      cb(e);
    }
  };

  const lastRowIndex = rows.length - 1;

  return rows.map((row, index) => (
    <tr
      key={row.id || index}
      className={cx('custom-table__tbody-row', {
        [row.className]: !!row.className,
        selectable: row.onSelectClick,
        selected: row.selected,
      })}
      style={{ height: row.minHeight || 'auto' }}
      onClick={e => handleClick(e, row.onSelectClick)}
      {...(row.htmlAttributes ? row.htmlAttributes : {})}
    >
      {row.cells.map((cell, cellIndex) => (
        <BodyCell
          key={`${row.id}-${cellIndex}`}
          cell={cell}
          stickyHeaderObserverAnchor={hasStickyHeader && lastRowIndex === index && cellIndex === 0}
        />
      ))}
    </tr>
  ));
};
